import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { environment } from 'src/environments/environment';

export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
    const cacheBuster = new Date().getTime(); 
    return new TranslateHttpLoader(http, `${environment.apiUri}/translations/`, `?v=${cacheBuster}`);
}
